/**
 * Credit-based learner-reading size. Keep in sync with
 * backend/src/utils/learningContentSizing.js
 */

export const WORDS_PER_CREDIT_MIN = 3000;
export const WORDS_PER_CREDIT_MAX = 3600;
export const WORD_MIN_FLOOR = 7000;
export const WORD_MAX_CEILING = 16000;
export const WORDS_PER_PDF_PAGE = 800;

export function resolveTaskCredits(task, module) {
  const own = Number(task?.credits);
  if (Number.isFinite(own) && own > 0) return own;
  const children = Array.isArray(task?.children) ? task.children : [];
  const childSum = children.reduce((sum, child) => sum + (Number(child.credits) || 0), 0);
  if (childSum > 0) return childSum;
  const mod = Number(module?.credits);
  if (Number.isFinite(mod) && mod > 0) return mod;
  return 3;
}

export function wordRangeFromCredits(credits) {
  const n = Number(credits);
  const effective = Number.isFinite(n) && n > 0 ? n : 3;
  let min = Math.round(effective * WORDS_PER_CREDIT_MIN);
  let max = Math.round(effective * WORDS_PER_CREDIT_MAX);
  min = Math.max(WORD_MIN_FLOOR, min);
  max = Math.min(WORD_MAX_CEILING, Math.max(max, min + 1500));
  return { min, max };
}

export function estimatedPdfPages(wordRange) {
  const min = Math.max(1, Math.round((wordRange.min || 0) / WORDS_PER_PDF_PAGE));
  const max = Math.max(min, Math.round((wordRange.max || 0) / WORDS_PER_PDF_PAGE));
  return { min, max };
}
